import * as React from 'react';
import Svg, {Path} from 'react-native-svg';

type GiftBoxProps = {
  width?: number;
  height?: number;
  color?: string;
  style?: Record<string, unknown>;
};
export default class GiftBoxDetail extends React.Component<GiftBoxProps> {
  render() {
    return (
      <>
        <Svg
          width={this.props.width || '54'}
          height={this.props.height || '54'}
          viewBox="0 0 54 54"
          fill="none"
        >
          <Path
            d="M21.0785 10.0766L24.2245 15.4284H24.1069H17.598C15.6001 15.4284 13.9819 13.8102 13.9819 11.8123C13.9819 9.81441 15.6001 8.19622 17.598 8.19622H17.7969C19.1439 8.19622 20.4005 8.91039 21.0785 10.0766ZM9.64265 11.8123C9.64265 13.1141 9.95905 14.3435 10.5105 15.4284H6.74979C5.14968 15.4284 3.85693 16.7211 3.85693 18.3212V24.1069C3.85693 25.707 5.14968 26.9998 6.74979 26.9998H47.2498C48.8499 26.9998 50.1426 25.707 50.1426 24.1069V18.3212C50.1426 16.7211 48.8499 15.4284 47.2498 15.4284H43.4891C44.0405 14.3435 44.3569 13.1141 44.3569 11.8123C44.3569 7.41876 40.7951 3.85693 36.4016 3.85693H36.2027C33.3189 3.85693 30.643 5.38472 29.1785 7.87077L26.9998 11.5863L24.8211 7.87981C23.3566 5.38472 20.6807 3.85693 17.7969 3.85693H17.598C13.2045 3.85693 9.64265 7.41876 9.64265 11.8123ZM40.0176 11.8123C40.0176 13.8102 38.3995 15.4284 36.4016 15.4284H29.8926H29.7751L32.9211 10.0766C33.6082 8.91039 34.8557 8.19622 36.2027 8.19622H36.4016C38.3995 8.19622 40.0176 9.81441 40.0176 11.8123ZM6.74979 29.8926V45.8034C6.74979 48.199 8.69343 50.1426 11.0891 50.1426H24.1069V29.8926H6.74979ZM29.8926 50.1426H42.9105C45.3062 50.1426 47.2498 48.199 47.2498 45.8034V29.8926H29.8926V50.1426Z"
            fill={this.props.color ?? '#003349'}
          />
        </Svg>
      </>
    );
  }
}
